Namespace 'Common.Sessions'

class Common.Sessions.SharingButton extends Backbone.View
  template: JST['backbone/templates/common/sessions/sharing_button']

  initialize: ({session}) ->
    @session = session
    @listenTo(@session, 'session:sharedSessionChange', @render)

  render: =>
    isSharedSession = @_sharedSession() != undefined
    @$el.html(@template(
      isSharedSession: isSharedSession,
    ))
    @$el.find('#dropdown-view').html(@_dropdown().render().el) if isSharedSession
    @$('#share-session').click(@_shareSession)
    @

  _sharedSession: =>
    @session.sharedSession

  _shareSession: =>
    sharedSessionModal = new Common.Sessions.SharedSessionModal session: @session
    sharedSessionModal.render()

  _dropdown: =>
    new Common.Sessions.SharingDropdown
      session: @session
